module.exports = __webpack_public_path__ + "img/avatar0.16af9cfc.png";